import GatewayPAAdditionalInfoToPurchasePagePolChange from './pages/AdditionalInfoToPurchase/AdditionalInfoToPurchasePagePolChange';

const customerGatewayPolicyChangePAComponentMap = {
    GatewayPAAdditionalInfoToPurchasePagePolChange: { component: 'GatewayPAAdditionalInfoToPurchasePagePolChange' },
};

const customerGatewayPolicyChangePAComponents = {
    GatewayPAAdditionalInfoToPurchasePagePolChange
};

export {
    customerGatewayPolicyChangePAComponentMap,
    customerGatewayPolicyChangePAComponents
}